import { Pipe, PipeTransform } from '@angular/core';
import { Platform } from "ionic-angular";
import { AppModule } from '../../app/app.module';
import { AppConfig } from '../../config/app.config';

@Pipe({
  name: 'currencyPipe',
})
export class CurrencyPipe implements PipeTransform {
  /**
   * transforms a number to a formatted currency string.
   */
  transform(value: number, ...args) {
    var config = AppModule.injector.get(AppConfig);
    var platform = AppModule.injector.get(Platform);

    if(platform.is('ios')) {
      return '€' + value.toFixed(2);
    } else {
      return value.toLocaleString(config.locale, { style: 'currency', currency: config.currency});
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/currency/currency.ts